import NewReleasesIcon from '@mui/icons-material/NewReleases'
import { Badge, IconButton, Tooltip } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
    iconButton: {
        color: '#fffffff2',
        padding: 4
    },
    icon: {
        fontSize: 26
    },
    badge: {
        fontSize: 10,
        height: 16,
        minWidth: 16
    }
}))

export type ReleaseNotesIconProps = {
    count: number
    onClick: () => void
}

export default function ReleaseNotesIcon({ count, onClick }: ReleaseNotesIconProps) {
    const { classes } = useStyles()

    return (
        <Tooltip title={count > 0 ? `${count} novidade(s) não lida(s)` : 'Novidades'}>
            <IconButton className={classes.iconButton} onClick={onClick}>
                <Badge
                    color="error"
                    badgeContent={count}
                    max={99}
                    overlap="circular"
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    classes={{ badge: classes.badge }}
                >
                    <NewReleasesIcon className={classes.icon} />
                </Badge>
            </IconButton>
        </Tooltip>
    )
}
